import ToggleItem from './toggle_item';

export default class Strike extends ToggleItem {
  constructor() {
    super('strike', 'Ctrl+U');
  }
}
